import ApiBase from './api-base'

export class TicketsIdn extends ApiBase {
  constructor(store) {
    const path = 'idn/messages'
    super(path, store)
  }
}

export class Tickets extends ApiBase {
  constructor(store) {
    const path = 'admin/messages'
    super(path, store)
  }
}

export class TicketMessages extends ApiBase {
  constructor(store) {
    const path = 'idn/message-details'
    super(path, store)
  }

  add(id, body) {
    return this._request({
      action: encodeURIComponent(id),
      method: 'POST',
      body
    })
  }

  unseenCount() {
    return this._request({
      action: 'unseen/count',
      method: 'GET'
    })
  }
}
